import './modules/module.js';
/**
 * サイトマップ
 */
const createList = (inner,id) => {
  const tmpDom = document.createElement('li');
  tmpDom.classList.add('sitemap__child-item');
  const anchor = document.createElement('a');
  anchor.href = homeUrl + '/works/' + id;
  anchor.title = inner + 'のページ';
  anchor.innerHTML = inner;
  tmpDom.appendChild(anchor);
  return tmpDom;
}
window.addEventListener('load',()=>{
  const sitemap = S('.jsSitemapLists');
  if(sitemap)
  {
    const url = httpUrl + 'blog.zaty.jp/wp-json/works/lists?count=-1&sitemap=1';
    fetch(url)
    .then( res => res.json() )
    .then( data => {
      data.shift();
      data.forEach((item, i) => {
        const client = item.client ? '【' + item.client + '】':'';
        const dom = createList(item.title + client,item.id);
        sitemap.appendChild(dom);
      });
    })
  }
  const aboutUs = S('.jsAboutUs');
  if(aboutUs)
  {
    const bgTitle = aboutUs.querySelector('.jsBgTitle');
    window.addEventListener('scroll', e => {
      bgTitle.style.transform = 'rotate(90deg) translateX(-'+ window.scrollY*2  +'px)';
    },{passive: true});
    const bgInfo = aboutUs.querySelector('.jsInfoBg');
    const infoObserveOptions = {
      rootMargin: "0px 0px -35%",
      threshold: 0
    };
    const infoObserveCallback = e => {
      if( e[0].isIntersecting )
      {
        e[0].target.classList.add('about-us__info-bg--visible');
      }
    }
    const infoObserver = new IntersectionObserver(infoObserveCallback, infoObserveOptions);
    infoObserver.observe(bgInfo);
  }
});
